// Contenu central du site Cleanova-Sud

export const SITE_URL = "https://cleanova-sud.fr";

export const COMPANY = {
  name: "Groupe Cleanova - Sud",
  shortName: "Cleanova-Sud",
  tagline: "Ménage & Conciergerie haut de gamme",
  city: "Béziers",
  phone: "07 83 51 69 85",
  phoneIntl: "+33783516985",
  whatsapp:
    "https://wa.me/33783516985?text=Bonjour%2C%20je%20vous%20contacte%20depuis%20votre%20site.",
  reviewLink: "https://g.page/r/CXX2uC5CMzVYEBM/review",
  cleaneo: "https://apps.cleanova-sud.fr/",
  hostbook: "https://hostbook.cleanova-sud.fr/",
};

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1777557269858-673318ce46d3",
  coastNight: "https://images.unsplash.com/photo-1772555429244-94ef41a100b2",
  cleaningBath:
    "https://images.pexels.com/photos/6899357/pexels-photo-6899357.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1400",
  bedroom:
    "https://images.pexels.com/photos/34688212/pexels-photo-34688212.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1400",
  luxLiving:
    "https://images.pexels.com/photos/8082227/pexels-photo-8082227.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1400",
  towels:
    "https://images.unsplash.com/photo-1724847885015-be191f1a47ef?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  basket: "https://images.unsplash.com/photo-1773450970959-cef81e9b1053?w=1200&q=80",
  basket2: "https://images.unsplash.com/photo-1773451592356-2e097e86aa44?w=1200&q=80",
  laptop:
    "https://images.pexels.com/photos/5717797/pexels-photo-5717797.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1400",
  brunch:
    "https://images.unsplash.com/photo-1504754524776-8f4f37790ca0?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
};

export const ZONES = [
  { name: "Béziers", note: "Centre-ville et périphérie" },
  { name: "Cap d'Agde", note: "Port, centre et naturiste" },
  { name: "Valras-Plage", note: "Front de mer et village" },
  { name: "Sérignan", note: "Plage et centre" },
  { name: "Vias", note: "Plage et alentours" },
  { name: "Portiragnes", note: "Plage et village" },
];

export const REVIEWS = [
  {
    name: "Manuel Caselas",
    date: "Visité en octobre 2025",
    text:
      "Nous avons récemment commencé à travailler avec Cleanova Sud et nous sommes très satisfaits. L'équipe est professionnelle, ponctuelle et efficace. Le travail est toujours bien fait et la communication est professionnelle. Nous recommandons cette entreprise sans hésiter.",
  },
  {
    name: "Melina Breguet",
    date: "Visité en octobre 2025",
    text:
      "Nous avons occupé un logement à Béziers dont l'entretien était assuré par Cleanova Sud. Tout était impeccable. Nous avons loué à la dernière minute et le temps de réaction pour nous apporter ce qu'il manquait a été super rapide. Je les remercie pour leur gentillesse.",
  },
  {
    name: "Oday Sarah",
    date: "Visité en octobre 2025",
    text:
      "Personne ponctuelle, très respectueuse, qui a du cœur à l'ouvrage. Un esprit engagé. Merci pour votre travail, votre attention, votre application et votre implication. Je recommande à 100%.",
  },
];

export const PROCESS = [
  {
    step: "01",
    title: "Premier contact",
    text: "Échangeons sur vos besoins spécifiques et les particularités de votre bien.",
  },
  {
    step: "02",
    title: "Visite & devis",
    text: "Nous évaluons votre logement et vous proposons une solution sur-mesure.",
  },
  {
    step: "03",
    title: "Mise en place",
    text: "Définition du planning et des procédures adaptées à vos attentes.",
  },
  {
    step: "04",
    title: "Excellence continue",
    text: "Prestations régulières avec contrôle qualité et suivi personnalisé.",
  },
];

export const MENAGE_FAQ = [
  {
    q: "Qu'est-ce qu'un ménage pour location saisonnière (Airbnb) ?",
    a: "Le ménage location saisonnière est un nettoyage professionnel réalisé entre chaque séjour : sols, surfaces, cuisine, salle de bain, WC, dépoussiérage, mise en place du linge et contrôle qualité. À Béziers et sur le littoral, Cleanova-Sud prépare votre logement pour offrir un rendu impeccable à chaque arrivée.",
  },
  {
    q: "Combien coûte un ménage Airbnb à Béziers ?",
    a: "Nos prestations de ménage démarrent à partir de 1,30 €/m². Le tarif final dépend de la surface, du nombre de lits, de la fréquence et des options (linge, lits faits, consommables). Nous établissons un devis clair et transparent, sans frais cachés.",
  },
  {
    q: "La gestion du linge et les lits faits sont-ils inclus ?",
    a: "Ces prestations sont proposées en option : lavage, séchage et repassage du linge, mise en place des draps et serviettes, et lits faits avant l'arrivée des voyageurs. Nous gérons aussi le stock de linge et son remplacement si nécessaire.",
  },
  {
    q: "À quelle fréquence intervenez-vous entre deux séjours ?",
    a: "Nous nous adaptons à votre calendrier de réservations, 7j/7, y compris pour les rotations rapides le jour même. Un contrôle qualité (check-list et photos) est réalisé à chaque intervention.",
  },
  {
    q: "Proposez-vous un tarif préférentiel aux conciergeries et professionnels ?",
    a: "Oui. Nous appliquons une remise pouvant aller jusqu'à 15% aux conciergeries et gestionnaires, selon la régularité des interventions et le volume de logements confiés.",
  },
];

export const CONCIERGERIE_FAQ = [
  {
    q: "Qu'est-ce qu'une conciergerie Airbnb à Béziers ?",
    a: "Une conciergerie Airbnb à Béziers prend en charge la gestion opérationnelle de votre location saisonnière : accueil des voyageurs, remise des clés, ménage entre chaque séjour, gestion du linge, préparation du logement et suivi propriétaire. Cleanova-Sud gère votre bien clé en main pour vous faire gagner du temps et améliorer vos avis.",
  },
  {
    q: "Combien coûte un service de conciergerie pour une location saisonnière ?",
    a: "Notre conciergerie est facturée à hauteur de 20% par nuitée (le ménage restant à la charge du locataire). Le tarif final dépend du logement, de la fréquence des séjours et des options choisies. Nous établissons un devis transparent et sans frais cachés, adapté à chaque propriétaire.",
  },
  {
    q: "Quelles communes couvrez-vous autour de Béziers ?",
    a: "Nous intervenons à Béziers, au Cap d'Agde, à Valras-Plage, Sérignan, Vias et Portiragnes, ainsi que sur l'ensemble du littoral héraultais. Contactez-nous pour confirmer la prise en charge de votre commune.",
  },
  {
    q: "Gérez-vous l'accueil des voyageurs et la remise des clés ?",
    a: "Oui. Nous assurons l'accueil physique ou autonome des voyageurs, la remise des clés (boîte à clés sécurisée ou serrure connectée), la présentation du logement et une assistance 7j/7 pendant tout le séjour.",
  },
  {
    q: "Comment une conciergerie améliore-t-elle mes avis et mon taux d'occupation ?",
    a: "Un logement impeccable, un accueil soigné et une réactivité 7j/7 augmentent la satisfaction des voyageurs, réduisent les avis négatifs et améliorent votre note globale. De meilleurs avis renforcent votre visibilité sur Airbnb et Booking, et donc votre taux d'occupation.",
  },
];

export const RATING = { value: "5.0", count: REVIEWS.length };

export const FAQ = [
  {
    q: "Qu'est-ce que Cleanova-Sud ?",
    a: "Cleanova-Sud est une entreprise spécialisée dans les services pour locations saisonnières : ménage Airbnb, conciergerie, gestion du linge, préparation de logements, paniers d'accueil et solutions digitales pour les professionnels.",
  },
  {
    q: "Quels services propose Cleanova-Sud pour les locations saisonnières ?",
    a: "Nous proposons : ménage location saisonnière, conciergerie Airbnb, linge, lits faits, contrôle qualité, préparation du logement, et options d'accueil (paniers, services voyageurs).",
  },
  {
    q: "Proposez-vous un service de ménage Airbnb ?",
    a: "Oui. Nous réalisons un ménage Airbnb professionnel adapté aux rotations rapides : nettoyage complet, remise en place et contrôle qualité avant l'arrivée des voyageurs.",
  },
  {
    q: "Que comprend un ménage pour location saisonnière ?",
    a: "Le nettoyage location saisonnière comprend : sols, surfaces, cuisine, salle de bain, WC, dépoussiérage, vérifications, et préparation du logement pour un rendu impeccable.",
  },
  {
    q: "Proposez-vous la gestion du linge et les lits faits ?",
    a: "Oui. Nous proposons la gestion du linge (collecte, lavage/pressing selon organisation, séchage, pliage, remise en place) et l'option lits faits avant l'arrivée des voyageurs.",
  },
  {
    q: "Qu'est-ce qu'une conciergerie Airbnb ?",
    a: "Une conciergerie Airbnb accompagne les hôtes dans la gestion opérationnelle : préparation du logement, coordination des interventions (ménage, linge), suivi qualité et services voyageurs.",
  },
  {
    q: "Pourquoi faire appel à une conciergerie pour une location courte durée ?",
    a: "Pour gagner du temps, standardiser la qualité, éviter les imprévus et améliorer les avis voyageurs. Une bonne organisation augmente la satisfaction et les performances de la location.",
  },
  {
    q: "Intervenez-vous sur Béziers et alentours ?",
    a: "Nous intervenons principalement sur Béziers et selon les besoins sur les communes proches et le littoral. Contactez-nous pour confirmer votre zone.",
  },
  {
    q: "Travaillez-vous avec des conciergeries et gestionnaires ?",
    a: "Oui. Nous collaborons avec des conciergeries, gestionnaires et propriétaires qui recherchent un partenaire fiable pour le ménage, le linge et la préparation des logements.",
  },
  {
    q: "Comment améliorez-vous les avis Airbnb (propreté, expérience) ?",
    a: "Grâce à une check-list, une organisation rigoureuse et un contrôle qualité. Un logement propre, bien préparé et cohérent réduit les avis négatifs et améliore la note globale.",
  },
  {
    q: "Proposez-vous des paniers d'accueil pour les voyageurs ?",
    a: "Oui. Nous proposons des paniers d'accueil (classique, gourmet, luxe) à déposer dans le logement, parfait pour créer un effet « waouh » et améliorer l'expérience voyageur.",
  },
  {
    q: "Peut-on créer un panier d'accueil sur-mesure ?",
    a: "Oui. Nous proposons des paniers sur-mesure selon le style du logement, la saison, le budget et vos préférences. Idéal pour personnaliser l'accueil et marquer les voyageurs.",
  },
  {
    q: "Qu'est-ce que l'application Cleanéo ?",
    a: "Cleanéo est une application conçue pour les entreprises de ménage et conciergeries : planification des interventions, suivi des logements, gestion des équipes et centralisation des informations.",
  },
  {
    q: "Qu'est-ce que l'application HostBook ?",
    a: "HostBook est un livret d'accueil digital pour locations saisonnières : instructions du logement, infos utiles, recommandations locales et accès simple pour les voyageurs.",
  },
  {
    q: "Combien coûtent vos services (ménage, conciergerie, options) ?",
    a: "Le tarif dépend de la surface, du nombre de lits, de la fréquence et des options (linge, lits faits, paniers d'accueil, etc.). Nous proposons un devis adapté à chaque logement.",
  },
  {
    q: "Sous combien de temps pouvez-vous démarrer ?",
    a: "Nous pouvons démarrer rapidement selon la zone et le planning. Pour un lancement optimal, contactez-nous quelques jours à l'avance afin d'organiser la première mise en place.",
  },
  {
    q: "Comment demander un devis et contacter Cleanova-Sud ?",
    a: "Contactez-nous via le site, téléphone ou WhatsApp. Donnez-nous la surface, le nombre de lits, la fréquence et vos options (linge, paniers, etc.) et nous vous envoyons un devis rapidement.",
  },
];

export const VALUES = [
  {
    title: "Excellence",
    text: "Nous visons la perfection dans chaque prestation. Pas de compromis sur la qualité.",
  },
  {
    title: "Fiabilité",
    text: "Ponctualité, rigueur et respect des engagements. Votre confiance est notre priorité.",
  },
  {
    title: "Proximité",
    text: "Une équipe locale, disponible et à l'écoute de vos besoins spécifiques.",
  },
  {
    title: "Réactivité",
    text: "Disponibles 7j/7 pour s'adapter à vos réservations et imprévus.",
  },
];

export const ENGAGEMENTS = [
  "Équipe formée et professionnelle",
  "Produits écologiques et respectueux",
  "Assurance responsabilité civile",
  "Contrôle qualité systématique",
  "Tarification transparente",
  "Sans engagement de durée",
];

export const PRICING = [
  { name: "Ménage traditionnel", unit: "m²", pub: "1,30 €", pro: "1,11 €" },
  { name: "Entretien standard", unit: "m²", pub: "0,90 €", pro: "0,86 €" },
  { name: "Grand nettoyage", unit: "m²", pub: "1,30 €", pro: "sur état" },
  { name: "Lavage & séchage", unit: "U", pub: "10,00 €", pro: "9,50 €" },
  { name: "Lavage + repassage", unit: "U", pub: "20,00 €", pro: "18,00 €" },
  { name: "Consommables", unit: "U", pub: "à partir de 2,00 €", pro: "à partir de 2,00 €" },
];

export const PRODUCTS = [
  {
    tag: "SUR-MESURE",
    name: "Panier sur-mesure",
    desc: "Nous composons selon le logement, le budget et le profil des voyageurs.",
    price: "Prix sur demande",
    cta: "Demander une composition",
    image: IMAGES.basket2,
    type: "contact",
  },
  {
    tag: "LUXE",
    name: "Panier Luxe",
    desc: "Sélection premium pour une expérience d'accueil exceptionnelle.",
    price: "45,00 €",
    cta: "Payer en ligne",
    image: IMAGES.basket,
    type: "pay",
    package_id: "luxe",
  },
  {
    tag: "GOURMAND",
    name: "Panier Gourmand",
    desc: "Le juste équilibre : gourmand, élégant, parfait pour la plupart des séjours.",
    price: "28,00 €",
    cta: "Payer en ligne",
    image: IMAGES.brunch,
    type: "pay",
    package_id: "gourmand",
  },
  {
    tag: "ESSENTIEL",
    name: "Panier Classique",
    desc: "Un accueil simple et efficace : l'essentiel pour bien démarrer le séjour.",
    price: "22,00 €",
    cta: "Payer en ligne",
    image: IMAGES.basket2,
    type: "pay",
    package_id: "classique",
  },
];

export const SERVICE_OPTIONS = [
  "Ménage professionnel",
  "Conciergerie",
  "Ménage + Conciergerie",
  "Boutique",
  "Application",
];

export const PROPERTY_OPTIONS = [
  "Appartement",
  "Maison",
  "Villa",
  "Studio",
  "Immeuble",
];
